import React from 'react';

const FullBlock = ({ data }) => {
  return (
    <section className={`full ${data.contentType}`}>
      <div className="container">
        {data.contentType === 'text' ? (
          <p>{data.content}</p>
        ) : (
          <img src={data.content} alt="Full width content" />
        )}
      </div>
    </section>
  );
};

export default FullBlock; 